__turbopack_context__.v({
  "container": "ApplyHeader-module__FHe70a__container",
  "containerFloat": "ApplyHeader-module__FHe70a__containerFloat",
  "containerSteps": "ApplyHeader-module__FHe70a__containerSteps",
  "fadeInItems": "ApplyHeader-module__FHe70a__fadeInItems",
  "link": "ApplyHeader-module__FHe70a__link",
  "linkActive": "ApplyHeader-module__FHe70a__linkActive",
  "logo": "ApplyHeader-module__FHe70a__logo",
  "menu": "ApplyHeader-module__FHe70a__menu",
  "menuDark": "ApplyHeader-module__FHe70a__menuDark",
  "spacing--lg": "ApplyHeader-module__FHe70a__spacing--lg",
  "spacing--md": "ApplyHeader-module__FHe70a__spacing--md",
  "spacing--sm": "ApplyHeader-module__FHe70a__spacing--sm",
  "spacing--xl": "ApplyHeader-module__FHe70a__spacing--xl",
  "spacing--xs": "ApplyHeader-module__FHe70a__spacing--xs",
  "spacing--xxl": "ApplyHeader-module__FHe70a__spacing--xxl",
  "spacing--xxs": "ApplyHeader-module__FHe70a__spacing--xxs",
  "spacing--xxxl": "ApplyHeader-module__FHe70a__spacing--xxxl",
  "spacing--xxxs": "ApplyHeader-module__FHe70a__spacing--xxxs",
  "wrapper": "ApplyHeader-module__FHe70a__wrapper",
});
